import {useMutation} from "react-query";
import {Admission} from "@reside/reside-api-admission";
import Alert from "react-s-alert";
import {ResidentService} from "../../../services/ResidentServices";
import {AdmissionFromSearch} from "../../../services/AdmissionsService";
import {getWorkflowLabel} from "../../../atoms/start-workflow/workflowMapping";

export const useLinkResidentToAdmission = (
  workflowType: string,
  toggleModal?: (admission?: Admission | AdmissionFromSearch) => void,
) => {
  return useMutation(
    ({
      admission_id,
      resident_id,
    }: {
      admission_id: string;
      resident_id: string;
    }) => ResidentService.linkResidentToWorkflow({admission_id, resident_id}),
    {
      onSuccess: () => {
        Alert.success(
          `${getWorkflowLabel(workflowType)} was successfully linked.`,
        );
        if (toggleModal) {
          toggleModal(undefined);
        }
      },
      onError: () => {
        Alert.error(`Failed to link ${getWorkflowLabel(workflowType)}.`);
      },
    },
  );
};
